export const leaveTypes = {
  casual: 'Casual',
  sick: 'Sick',
  paid: 'Paid'
};

export const leaveStatuses = {
  pending: 'Pending',
  approved: 'Approved',
  rejected: 'Rejected'
};

export const years = [2026, 2025, 2024];
